module.exports = __webpack_public_path__ + "media/images/games/cs-go/rectangle-78eadff4a22a7a5c4d0dd0572fbf6172.jpg";